<!-- eslint-disable max-len -->
<template>
  <v-card :min-height="minHeight">
    <v-card-title class="primary--text">
      <span>
        <v-icon :color="iconColour">{{ icon }}</v-icon>
        <v-icon :color="iconColour" left>mdi-ferry</v-icon>
      </span>
      <span> {{ directionString | capitalise }}</span>
      <span> - </span>
      <span v-if="voyage">{{ voyage.voyageNo }} </span>
      <span v-else>Not Found</span>
    </v-card-title>
    <v-card-subtitle class="text-start">
      <span v-if="voyage"
        >Sailing Date:
        {{ voyage.sailingDate | removeTAndSecondsAndFormatDate }}</span
      >
    </v-card-subtitle>
    <div v-if="voyage">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" lg="6" xl="6">
            <div>
              <span
                class="body-1 text-truncate"
                v-text="
                  `Lifts: ${voyage.numberOfLiftsComplete}/${voyage.numberOfLifts}`
                "
              ></span>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="6">
            <span
              class="body-1"
              v-text="
                `DG Lifts: ${voyage.numberOfDgLiftsComplete}/${voyage.numberOfDgLifts}`
              "
            ></span>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="6">
            <span
              class="body-1"
              v-text="
                `Heavy Lifts: ${voyage.numberOfHeavyLiftsComplete}/${voyage.numberOfHeavyLifts}`
              "
            ></span>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="6">
            <span
              class="body-1"
              v-text="
                `Priority Lifts: ${voyage.numberOfPriorityLiftsComplete}/${voyage.numberOfPriorityLifts}`
              "
            ></span>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="6">
            <span
              class="body-1"
              v-text="`No. of ROB: ${voyage.numberOfRob}`"
            ></span>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="6">
            <span
              class="body-1"
              v-text="
                `Lifting Started: ${voyage.hasLiftingStarted ? 'Yes' : 'No'}`
              "
            ></span>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'VoyagePlanInboundOutboundVoyageCard',
  props: {
    voyage: {
      type: Object,
    },
    directionString: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      inboundArrow: 'mdi-arrow-right-bold',
      outboundArrow: 'mdi-arrow-left-bold',

      inboundColour: '#e30a17',
      outboundColour: '#003391',
    };
  },
  computed: {
    icon() {
      const direction = this.directionString;
      if (direction === 'inbound') return this.inboundArrow;

      return this.outboundArrow;
    },
    iconColour() {
      const direction = this.directionString;
      switch (direction) {
        case 'inbound':
          return this.inboundColour;
        case 'outbound':
          return this.outboundColour;
        default:
          return this.outboundColour;
      }
    },
    minHeight() {
      const breakpoint = this.$vuetify.breakpoint.name;
      switch (breakpoint) {
        case 'sm':
          return '440';
        default:
          return '270';
      }
    },
  },
};
</script>
